import React, { useState, useEffect } from 'react'
import { Form } from "antd";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../../components/CustomModal";
import Button from "../../../../newUXComponents/Button";
import useNotification from "../../../../hooks/newUXNotification";
import TelephoneInput,  {
  getFullTelephoneNumber,
  removeCountryFromTelephoneNumber,
  getCountryFromTelephoneNumber
} from "../../../../newUXComponents/TelephoneInput";
import Input from "../../../../newUXComponents/Input";
import Select from "../../../../newUXComponents/Select";
import { validation, INITIAL_VALUES } from "./validations";
import {
  Container,
  Header,
  Title,
  Hr,
  FormContainer,
  ButtonContainer
} from './styles'
import { 
  postCredentialSchedule,
  editCredentialSchedule,
  getCredentialSchedule,
  getCredentialScheduleAvailablePlaces,
  getCredentialScheduleAvailableDates,
  getCredentialScheduleAvailableTimes,
  clearCredentialScheduleAvailablePlaces,
  clearCredentialScheduleAvailableDates,
  clearCredentialScheduleAvailableTimes
} from '../../../../redux/modules/credentials/actions';

const ScheduleModal = ({ 
    open,
    id,
    handleClose,
    credentialSchedule = {},
    event,
    contract,
    isEdit=false
  })=>{
  const [defaultCountry, setDefaultCountry] = useState('BR')

  const [isOpen, setIsOpen] = useState(open)
  const intl = useIntl();
  const [form] = Form.useForm();
  const notification = useNotification();
  const dispatch = useDispatch();
  const {
    credentialScheduleAvailablePlaces,
    credentialScheduleAvailableDates,
    credentialScheduleAvailableTimes
  } = useSelector((state) => state.credentials);

  const callbackError = (message) =>
    notification.displayError(intl.formatMessage({id: "api.error." + message}), 'get-collaborators-error-message')
  
  const callbackSuccess = (message) => {
    notification.displaySuccess(intl.formatMessage({id: "success." + message}), 'post-new-employee-success-message')
    dispatch(getCredentialSchedule( event.value, contract.value, callbackError ))
    handleClose()
  }

  const confirmModal = () => {
    form.validateFields().then(() => {
      const id = credentialSchedule.credentialScheduleId
        ? credentialSchedule.credentialScheduleId
        : ""
      const params = {
        contact: getFullTelephoneNumber(
          form.getFieldValue('telephone'),
          form.getFieldValue('telephone_selected_country').value,
          defaultCountry
        ),
        nameOfWhoWithdraws: form.getFieldValue('name'),
        opportunityId: contract.value,
        eventId: event.value,
        withdrawalPlaceId: form.getFieldValue('withdrawalPlace'),
        date: form.getFieldValue('date'),
        time: form.getFieldValue('hour')
      }

      if (isEdit)
        dispatch(editCredentialSchedule(params, id, callbackError, callbackSuccess))
      else
        dispatch(postCredentialSchedule(params, callbackError, callbackSuccess))
    })
    .catch((error) => {
    })
  }

  const handlePlaceChange = () => {
    dispatch(clearCredentialScheduleAvailableDates());
    dispatch(clearCredentialScheduleAvailableTimes());
    form.setFieldValue('date', "");
    form.setFieldValue('hour', "");

    const place = form.getFieldValue('withdrawalPlace');

    dispatch(
      getCredentialScheduleAvailableDates(
        {
           event_id: event.value,
           place_id: place,
        },
        callbackError
      )
    );
  }

  const handleDateChange = () => {
    dispatch(clearCredentialScheduleAvailableTimes());
    form.setFieldValue('hour', "");

    const place = form.getFieldValue('withdrawalPlace');
    const date = form.getFieldValue('date');
    const id = credentialSchedule.credentialScheduleId
      ? credentialSchedule.credentialScheduleId
      : 0;

    dispatch(
      getCredentialScheduleAvailableTimes(
        {
           event_id: event.value,
           schedule_id: id,
           date: date,
           place_id: place,
        },
        callbackError
      )
    );
  }

  useEffect(() => {
    dispatch(clearCredentialScheduleAvailablePlaces());
    dispatch(clearCredentialScheduleAvailableDates());
    dispatch(clearCredentialScheduleAvailableTimes());

    dispatch(
      getCredentialScheduleAvailablePlaces(
        {
           event_id: event.value,
        },
        callbackError
      )
    );

    if (isEdit) {
      dispatch(
        getCredentialScheduleAvailableDates(
          {
             event_id: event.value,
             place_id: credentialSchedule.withdrawalPlace.value,
          },
          callbackError
        )
      );

      if (credentialSchedule.dateIsAnOptionInsideSchedulePeriod) {
        dispatch(
          getCredentialScheduleAvailableTimes(
            {
               event_id: event.value,
               schedule_id: credentialSchedule.credentialScheduleId,
               date: credentialSchedule.dateSchedule,
               place_id: credentialSchedule.withdrawalPlace.value,
            },
            callbackError
          )
        );
      }

      form.setFieldValue('withdrawalPlace', credentialSchedule.withdrawalPlace.value)
      if (credentialSchedule.dateIsAnOptionInsideSchedulePeriod)
        form.setFieldValue('date', credentialSchedule.dateSchedule)
      if (credentialSchedule.timeIsAnOptionInsideSchedulePeriod)
        form.setFieldValue('hour', credentialSchedule.timeSchedule)
      form.setFieldValue('name', credentialSchedule.nameOfWhoWithdraws)

      if (credentialSchedule.contact.length !== 0 && !!credentialSchedule.contact){
        form.setFieldsValue({
          telephone: removeCountryFromTelephoneNumber(credentialSchedule.contact),
          telephone_selected_country: getCountryFromTelephoneNumber(
            credentialSchedule.contact
          ).value,
        });
        setDefaultCountry(getCountryFromTelephoneNumber(credentialSchedule.contact).value)
      }
      else
        form.setFieldsValue({
          telephone: "",
          telephone_selected_country: "",
        });
    }
  },[])

  return (
    <CustomModal handleClose={handleClose} isModalVisible={isOpen} id={id}>
      <Container>
        <Header>
          <Title>{intl.formatMessage({ id: isEdit? "edit_scheduling": "new_scheduling" })}</Title>
        </Header>
        <Hr />
        <FormContainer>
          <Form
            layout="vertical"
            form={form}
            name="new-employee"
            onFinish={confirmModal}
            initialValues={INITIAL_VALUES}
          >
            <Select
              name="withdrawalPlace"
              label={intl.formatMessage({ id: "withdrawal_place" })}
              showArrow
              allowClear
              placeholder={intl.formatMessage({ id: "withdrawal_place" })}
              rules={validation("withdrawalPlace", intl)}
              onChange={(e) => handlePlaceChange(e)}
              options={credentialScheduleAvailablePlaces}
            />
            <Select 
              name="date"
              label={intl.formatMessage({ id: "date" })}
              showArrow
              allowClear
              placeholder={intl.formatMessage({ id: "date" })}
              rules={validation("date", intl)}
              onChange={(e) => handleDateChange(e)}
              options={credentialScheduleAvailableDates}
            />
            <Select 
              name="hour"
              label={intl.formatMessage({ id: "schedule_time" })}
              showArrow
              allowClear
              placeholder={intl.formatMessage({ id: "schedule_time" })}
              rules={validation("hour", intl)}
              options={credentialScheduleAvailableTimes}
            />
            <Input
              type="text"
              name="name"
              label={intl.formatMessage({ id: "name_of_who_withdraws" })}
              placeholder={intl.formatMessage({ id: "name_of_who_withdraws" })}
              rules={validation('name', intl)}
            />
            <TelephoneInput
              name="telephone"
              placeholder={intl.formatMessage({
                id: "telephone",
              })}
              label={intl.formatMessage({
                id: "telephone",
              })}
              rules={validation("telephone", intl)}
              refForm={form}
              defaultCountryCode={defaultCountry}
            />
          <ButtonContainer>
            <Button 
              label={intl.formatMessage({ id: "confirm" })}
              type="primary"
              onClick={confirmModal}
            />
            <Button 
              label={intl.formatMessage({ id: "cancel" })}
              type='link'
              onClick={handleClose}
            />
          </ButtonContainer>
          </Form>
        </FormContainer>
      </Container>
    </CustomModal>
  )
}

export default ScheduleModal